import React, { useRef } from "react";
import "./SquareGrid.css";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import { SendIcon } from "./icons";

interface ManualInputProps {
  maxSquares?: number;
  newInput: (value: number) => void;
  matches?: boolean;
  start?: number;
  label?: string | null;
}

const ManualInput: React.FC<ManualInputProps> = ({
  maxSquares = 9999,
  newInput,
  matches = true,
  start = 25,
  label = matches ? "Squares" : null,
}) => {
  const numberRef = useRef<HTMLInputElement | null>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  function onEnter() {
    const raw = numberRef.current?.value ?? String(start);
    const value = Number(raw);
    if (!Number.isNaN(value)) {
      newInput(value);
    }
  }

  return (
    <span>
      <TextField
        sx={{ maxWidth: "90%" }}
        variant="standard"
        color="error"
        id="SquaresInput"
        InputProps={{
          inputProps: {
            max: maxSquares,
            min: 0,
          },
        }}
        label={label ?? undefined}
        type="number"
        defaultValue={start}
        inputRef={numberRef}
        onKeyDown={(ev) => {
          if (ev.key === "Enter") {
            buttonRef.current?.click();
            ev.preventDefault();
          }
        }}
      />
      <IconButton
        aria-label="input"
        ref={buttonRef}
        onClick={onEnter}
        size="small"
      >
        <SendIcon ic="" />
      </IconButton>
    </span>
  );
};

export default ManualInput;


